export interface OGTag {
  property: string;
  content: string;
}

export type PageMetaDict = {
  [pathname: string]: {
    og: OGTag[];
  };
  default: {
    og: OGTag[];
  };
};

const defaultOgTags = [
  { property: "site_name", content: "expressdesign.vn" },
  { property: "locale", content: "vi_VN" },
  { property: "locale:alternate", content: "en_US" },
];

export const PAGE_META_DICT: PageMetaDict = {
  "/": {
    og: [
      { property: "title", content: "Express Design" },
      {
        property: "description",
        content:
          "Website đặt hàng thiết kế trực tuyến - Đặt thiết kế trong 5 phút nhận sản phẩm ngay trong ngày",
      },
      { property: "type", content: "website" },
      { property: "image", content: "article" },
      { property: "url", content: "http://expressdesign.vn" },
      ...defaultOgTags,
    ],
  },
  default: {
    og: [],
  },
};



// WEBPACK FOOTER //
// ./src/head/constants.ts